import type { ReactElement } from 'react';

import type { DrupalTerm } from '@commons/types/drupal';

import InsightTopicTerm from './InsightTopic';

/**
 * Enum of all available term bundles.
 *
 * Makes it easier to read and edit the bundles.
 */

export enum TERM_BUNDLE {
  InsightTopic = 'insight_topic',
}

/**
 * Generic type for the term components.
 *
 * It has the base `DrupalTerm` type and infer additional properties based on the term type.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Term = (props: DrupalTerm & any) => ReactElement;

/**
 * Factory type for all terms.
 *
 * It uses `string` instead of `TERM_TYPE` as key so that each site can have its own terms.
 */

export type TermsFactory = Record<string, Term>;

/**
 * Factory of all available terms.
 */

export const terms: TermsFactory = {
  [TERM_BUNDLE.InsightTopic]: InsightTopicTerm,
};
